import React, { useEffect } from 'react';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Morebtn from 'components_v2/desktop/Morebtn';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './AboundSignUpLoggedIn.scss';
import { IMAGE_URL } from '../../../constants';

const AboundSignUpLoggedIn = props => {
  const { subscribeAndSignupAbound, handleClosePopup, label } = props;

  const handleContinue = () => {
    if (typeof subscribeAndSignupAbound === 'function') {
      subscribeAndSignupAbound();
      if (typeof handleClosePopup === 'function') {
        handleClosePopup(false);
      }
    }
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'continue_consent_pop_up',
      label: label || 'popup_manager',
      category: 'abound',
    });
  };

  useEffect(() => {
    analyticsWrapper('ga4', {
      event: 'user_shown',
      type: 'consent_pop_up',
      label: label || 'popup_manager',
      category: 'abound',
    });
  }, []);

  return (
    <div className={s.AboundPopupwrapper}>
      <h2 className={s.heading}>
        Get <span>₹1000 ($10) Welcome Bonus</span>
        <br />
        on Abound by <ImageV2 src={`${IMAGE_URL}125717268.cms`} alt="Earn" />
      </h2>

      <div className={s.AboundInfoCard}>
        <p className={s.AboundInfoText}>
          Use Abound to send money at the <br />
          <span className={s.highlight}>
            Highest Fx Rate: <span className={s.blue}>$1 = ₹100</span>
          </span>
        </p>

        <ImageV2 src={`${IMAGE_URL}125687090.cms`} alt="Earn" />
      </div>

      <div className={s.consentCTA}>
        <p>By continuing, you agree to create an Abound account</p>
        <Morebtn moreText="CONTINUE" redbg noArrow onClick={handleContinue} />
      </div>
    </div>
  );
};

export default AboundSignUpLoggedIn;
